import { render } from "./CreateRound.vue?vue&type=template&id=5b0a5168&scoped=true"
import script from "./CreateRound.vue?vue&type=script&lang=js"
export * from "./CreateRound.vue?vue&type=script&lang=js"

import "./CreateRound.vue?vue&type=style&index=0&id=5b0a5168&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b0a5168"

export default script